<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="title-heading d-flex justify-content-between">

          <div class="back-link integration-link">
            <router-link :to="{ name: 'SettingsDeliveries' }">
              <span class="icon icon-left"></span>
              <span class="link-text">{{ $static('delivery.title3', 'Мої доставки') }}</span>
            </router-link>
          </div>
          <h1>{{ $static('delivery.ff10', 'Усі інтеграції') }}</h1>

        </div>

        <!--        <div class="large-button-panel">-->
        <!--          <div class="search-panel w-100">-->
        <!--            &lt;!&ndash;search panel&ndash;&gt;-->
        <!--            <div class="search-group">-->
        <!--              <input type="text" class="input-search form-control custom-input" placeholder="Знайти">-->
        <!--              <button class="search-btn" @click="getItems">-->
        <!--                <span class="icon icon-search"></span>-->
        <!--              </button>-->
        <!--            </div>-->
        <!--            &lt;!&ndash; end search panel&ndash;&gt;-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="integrations-wrapper">
          <div class="integration-grid to-add-integrations">
            <div class="integration-item" v-for="(item, index) in list" :key="index">
              <div class="item-holder">
                <div class="logo" v-if="item.manifest && item.manifest.icon">
                  <img :src="item.manifest.icon" :alt="item.name">
                </div>
                <div class="logo" v-else>
                  {{ item.name }}
                </div>
                <p v-if="item.description" v-html="item.description"></p>
                <div class="button-panel">
                  <button class="default-btn btn-white btn-green editor_trigger" @click="openEditor(item)">
                    <span class="text">{{ $static('delivery.add-new', 'Додати') }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!--            <div class="integration-item custom-item">-->
            <!--              <div class="item-holder">-->
            <!--                <div class="logo">-->
            <!--                  <img src="/images/stack.png" alt="custom">-->
            <!--                </div>-->
            <!--                <div class="button-panel">-->
            <!--                  <button class="default-btn btn-white editor_trigger" @click="openEditor">-->
            <!--                    <span class="text">Створити</span>-->
            <!--                  </button>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <!-- EDITOR WRAPPER-->
    <div class="overlay-editor item-editor">
      <div class="overlay-editor-wrapper" v-if="selected">
        <div class="panel-top">

          <div class="lang-selector-holder d-flex align-items-center">
            <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:') }}</label>
            <LangSelector v-model="lang" />
          </div>

          <a href="javascript:void(0);" class="back_trigger" @click="cancel">
            <span class="icon icon-cross"></span>
          </a>
        </div>
        <PluginEditor :selected="selected" :title="'Редагування способу доставки'" :lang="lang"></PluginEditor>
        <div class="panel-bottom">
          <button class="transparent-btn default-btn back_trigger" @click="cancel">
            <span class="text">{{ $static('sdd.cancel', 'Скасувати') }}</span>
          </button>
          <button class=" default-btn btn-accent" @click="save">
            <span class="text">{{ $static('sdd.save', 'Додати') }}</span>
          </button>
        </div>
      </div>
    </div>
    <!--END EDITOR WRAPPER-->
  </Teleport>

</template>

<script>
import api from '@/api'
import LangSelector from '../components/LangSelector';
import PluginEditor from './PluginEditor';

export default {
  name: 'SettingsDeliveries',
  components: { PluginEditor, LangSelector },
  data() {
    return {
      lang: '',
      list: [],
      selected: undefined
    }
  },
  computed: {
    langs() {
      return this.$store.getters.settings
        && this.$store.getters.settings.public
        && this.$store.getters.settings.public.lang
        && Array.isArray(this.$store.getters.settings.public.lang) ?
        this.$store.getters.settings.public.lang : []
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      api.get('/api/plugin/estimate').then(response => response.data).then(data => {
        if (data) {
          this.list = data.filter(i => i.type === 'delivery')
        }
      })
    },
    cancel() {
      this.selected = false;
      window.$('body').removeClass('is-hidden');
      window.$('body > .active').removeClass('active');
    },
    openEditor(item, event) {
      this.selected = item;
      let autoComplete = true;
      if (this.selected.manifest && this.selected.manifest.form) {
        autoComplete = false
      }
      if (this.selected.settings && this.selected.settings.form) {
        autoComplete = false
      }
      if (autoComplete) {
        this.save();
        return
      }
      // window.$(event.target).toggleClass('open');
      window.$('.filter_sidebar').removeClass('active');
      window.$('body').addClass('is-hidden');

      window.$('.back-blur').toggleClass('active');
      window.$('.overlay-editor.item-editor').toggleClass('active');
    },
    save() {
      if (this.load) {
        return
      }
      this.load = true;
      this.selected.status = 'active';
      api.post('/api/plugin/install', this.selected).then(() => {
        this.load = false;
        this.cancel();
        this.$router.push({ name: 'SettingsDeliveries' });
        this.$notify({
          title: this.$static('notify.delivery-title', 'Доставка'),
          text: this.$static('notify.add', 'Додано'),
          duration: 3000
        });
      })
    }
  }
}
</script>

<style scoped></style>